import React from "react";
import "./partners.scss";

import azhur from "../../assets/azhur.png";
import mot from "../../assets/mot.png";
import internom from "../../assets/internom_brand.png";
import ot from "../../assets/ot_edu.png";

const partners = [
  {
    name: "Internom",
    logo: internom,
    link: "https://internom.mn/%D0%B1%D0%B0%D1%80%D0%B0%D0%B0/9789919051709-ochiroo%E2%80%99s-theory",
  },
  {
    name: "MOT Capital",
    logo: mot,
    link: "https://my.motcapital.com/auth/register?contractNo=OT",
  },
  {
    name: "Ot.edu",
    logo: ot,
    link: "https://www.instagram.com/ochir_edu_academy/",
  },
  {
    name: "Amazon",
    logo: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg",
    link: "https://a.co/d/02TCC66Y",
  },
  {
    name: "Azhur",
    logo: azhur,
    link: "https://book.mn/product/Ochiroo-s-Theory-Sanhuugiin-erh-choloonii-dzam-33632",
  },
];

const Partners = () => {
  return (
    <section className="partners">
      <div className="partners__container">
        <h2 className="partners__title">Хамтрагч Байгууллага</h2>

            <div className="partners__list">
            {partners.map((item, i) => (
                <a
                key={i}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className={`partners__item`}
                >
                <img src={item.logo} alt={item.name} />
                </a>
            ))}
            </div>
      </div>
    </section>
  );
};

export default Partners;